import { oz } from '@weft/utils';
import { LINE_ITEM_TYPES } from '../../line-item-type-schema';
import { BasePromotionLineItemSchema } from '../base-promotion-line-item-schema';

export const NewPromotionLineItemSchema = BasePromotionLineItemSchema.extend({
  type: oz.literal(LINE_ITEM_TYPES.Promotion),
}).openapi('NewPromotionLineItem');

export type NewPromotionLineItem = oz.infer<typeof NewPromotionLineItemSchema>;